import { render, staticRenderFns } from "./chartJetton.vue?vue&type=template&id=7bc0724a&scoped=true"
import script from "./chartJetton.vue?vue&type=script&lang=js"
export * from "./chartJetton.vue?vue&type=script&lang=js"
import style0 from "./chartJetton.vue?vue&type=style&index=0&id=7bc0724a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc0724a",
  null
  
)

export default component.exports